<template>
  <div class="fang_mail">
    <div class="main1_position" v-show="this.list_two == 1"></div>
    <div class="main1_warp">
      <!-- 按钮部分 -->

      <div class="main1" v-show="this.list_two == 1" id="main_btn">
        <el-button type="primary" @click="back">{{
          $t("list.return")
        }}</el-button>
        <el-button
          @click="xiazai"
          v-if="this.authority_to_judge.download_message==1"
          :disabled="$root.jurisdiction.only_query == 0"
          >{{ $t("list.download") }}</el-button
        >
        <!-- 上报垃圾 -->
        <el-button
          v-if="this.readmsg_show == 1"
          @click="report_msg"
          :disabled="$root.jurisdiction.only_query == 0"
          >{{ $t("logs.as_good") }}</el-button
        >
        <el-button
          @click="pass"
          v-if="this.has_pass_style == 0 && this.data_bulkpass_show == 1 &&this.authority_to_judge.pass==1"
          :disabled="$root.jurisdiction.only_query == 0"
          >{{ $t("list.pass") }}</el-button
        >
        <el-button
          @click="dawdata"
          v-if="this.authority_to_judge.rawdata==1"
          :disabled="$root.jurisdiction.only_query == 0"
          >{{ $t("list.rawdata") }}</el-button
        >
        <el-button @click="header"  :disabled="$root.jurisdiction.only_query == 0">{{ $t("list.header") }}</el-button>
        <el-button @click="reason"  :disabled="$root.jurisdiction.only_query == 0 || this.readmsg_disabled==0">{{ $t("list.whyspam") }}</el-button>
        <el-button @click="abstract" v-if="this.abstract_show == 1 &&this.authority_to_judge.show_digest==1"  :disabled="$root.jurisdiction.only_query == 0 || this.readmsg_disabled==0">{{
          $t("list.show")
        }}</el-button>
             <!-- <el-select v-model="value" clearable placeholder="" size="mini">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select> -->
        <el-button @click="matter" v-if="this.abstract_show == 1 &&this.authority_to_judge.show_digest==1"  :disabled="$root.jurisdiction.only_query == 0 || this.readmsg_disabled==0">{{
          $t("list.body")
        }}</el-button>
        <el-button @click="original" v-if="this.original_show == 1 &&this.authority_to_judge.printoriginalbody==1"  :disabled="$root.jurisdiction.only_query == 0 || this.readmsg_disabled==0">{{
          $t("list.origin")
        }}</el-button>
          <!-- 详细信息 -->
         <el-button
          @click="detail_click_show"
          v-if="this.detail_info_show==1"
           :disabled="$root.jurisdiction.only_query == 0 "
         
          >{{ $t("list.detail") }}</el-button
        >
        <el-button @click="print" v-if="this.print_show == 1 &&this.authority_to_judge.printparticipleinfo==1"  :disabled="$root.jurisdiction.only_query == 0 || this.readmsg_disabled==0">{{
          $t("list.info")
        }}</el-button>
        <el-button
          v-if="this.trainspam_show == 1"
          :disabled="$root.jurisdiction.only_query == 0"
          >{{ $t("list.trainspam") }}</el-button
        >
        <el-button
          v-if="this.trainspam_show == 1"
          :disabled="$root.jurisdiction.only_query == 0"
          >{{ $t("list.trainnormal") }}</el-button
        >
        <el-button
          v-if=" this.authority_to_judge.delete==1"
          @click="readmsg_sum"
          :disabled="$root.jurisdiction.only_query == 0"
          >{{ $t("logs.Conditional8") }}</el-button
        >
        <el-button type="text" @click="up_email">{{
          $t("logs.up_mail1")
        }}</el-button>
        <el-button type="text" @click="next_email">{{
          $t("logs.next_mail1")
        }}</el-button>
      </div>
    </div>
    <div class="xin" id="detail_type">
      <div class="switch" v-show="this.list_first == 1">
        <!-- 查询框 -->
        <div class="main">
          <el-form ref="form" label-width="80px">
            <ul>
              <li>{{ $t("wasteInsulate1.envfrom") }}:</li>
              <el-input placeholder v-model="col.envfrom" clearable></el-input>
              <li>{{ $t("wasteInsulate1.envrcpt") }}:</li>
              <el-input placeholder v-model="col.envrcpt" clearable></el-input>
              <li>{{ $t("wasteInsulate1.subject") }}:</li>
              <el-input placeholder v-model="col.subject" clearable></el-input>
              <li>{{ $t("wasteInsulate1.ip") }}:</li>
              <el-input placeholder v-model="col.ip" clearable></el-input>
              <el-button @click="tanSend">{{ $t("table.search") }}</el-button>
              <el-button
                @click="xians()"
                v-show="geng"
                type="text"
                class="more_s"
                >{{ $t("table.more") }}
              </el-button>
              <el-button
                @click="xians()"
                v-show="geng1"
                type="text"
                class="more_d"
                >{{ $t("table.more1") }}</el-button
              >
            </ul>
          </el-form>
          <div class="search" v-show="xian">
            <ul>
              <li>{{ $t("wasteInsulate1.hdrfrom") }}:</li>
              <el-input placeholder v-model="col.hdrfrom" clearable></el-input>

              <li>{{ $t("wasteInsulate1.hdrto") }}:</li>

              <el-input placeholder v-model="col.hdrto" clearable></el-input>
              <li>{{ $t("wasteInsulate1.attach") }}:</li>
              <el-input placeholder v-model="col.attach" clearable></el-input>
              <li>{{ $t("wasteInsulate1.attnum") }}:</li>
              <el-input placeholder="" v-model="col.nbattach">
                <el-select v-model="col.achunit" slot="prepend" placeholder="">
                  <el-option label=">=" value="1"></el-option>
                  <el-option label="<=" value="2"></el-option>
                  <el-option label="=" value="3"></el-option>
                </el-select>
              </el-input>
            </ul>
            <ul  v-if="this.ping_an_show==0">
              <li>{{ $t("wasteInsulate1.mid") }}:</li>

              <el-input placeholder v-model="col.mid" clearable></el-input>
              <li>{{ $t("wasteInsulate1.url") }}:</li>
              <el-input placeholder v-model="col.url" clearable></el-input>
              <li>{{ $t("wasteInsulate1.bccnum") }}:</li>
              <el-input placeholder="" v-model="col.nbbcc">
                <el-select v-model="col.bccunit" slot="prepend" placeholder="">
                  <el-option label=">=" value="1"></el-option>
                  <el-option label="<=" value="2"></el-option>
                  <el-option label="=" value="3"></el-option>
                </el-select>
              </el-input>

              <li>{{ $t("wasteInsulate1.alinknum") }}:</li>
              <el-input placeholder="" v-model="col.nblink">
                <el-select v-model="col.linkunit" slot="prepend" placeholder="">
                  <el-option label=">=" value="1"></el-option>
                  <el-option label="<=" value="2"></el-option>
                  <el-option label="=" value="3"></el-option>
                </el-select>
              </el-input>
            </ul>
            <ul   v-if="this.ping_an_show==0">
              <li>{{ $t("wasteInsulate1.body") }}:</li>

              <el-input placeholder v-model="col.body" clearable></el-input>

              <li>{{ $t("wasteInsulate1.istls") }}:</li>

              <el-select v-model="col.istls" placeholder>
                <el-option
                  v-for="item in istls_arr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <li>{{ $t("wasteInsulate1.haspass") }}:</li>

              <el-select v-model="col.haspass">
                <el-option
                  v-for="item in haspass1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <li>{{ $t("wasteInsulate1.type") }}:</li>

              <el-select v-model="col.type">
                <el-option
                  v-for="item in type1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </ul>
            <ul>
              <li>{{ $t("wasteInsulate1.minion_host") }}:</li>

              <el-select v-model="col.minion_host">
                <el-option
                  v-for="item in minionhost"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <li>{{ $t("logs.Policy_list8") }}:</li>
              <el-select v-model="col.isout" placeholder>
                <el-option
                  v-for="item in isout_arr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <li>{{ $t("wasteInsulate1.spam_reason") }}:</li>

              <el-select
                v-model="col.spam_reason"
                placeholder
                @change="spam_reason_change"
              >
                <el-option
                  v-for="item in spamreason"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input
                placeholder
                v-model="col.subwhy"
                clearable
                v-if="this.subwhy == 1"
              ></el-input>
              <li>{{ $t("tab.sort") }}:</li>

              <el-select
                v-model="col.q_order_type"
                slot="prepend"
                placeholder=""
                style="width:10%;padding-right:0px"
              >
                <el-option
                  v-for="item in q_order_type_arr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                v-model="col.q_order_sort"
                slot="prepend"
                placeholder=""
                style="width:7%;padding-left:0px"
              >
                <el-option
                  v-for="item in q_order_sort_arr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </ul>
            <ul>
              <li>{{ $t("wasteInsulate1.bigs") }}:</li>
              <div class="mailSize">
                <el-input v-model="col.min_size"></el-input>
                <el-select v-model="col.min_size_unit" placeholder="MB">
                  <el-option
                    v-for="item in size_unit"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option> </el-select
                >{{ $t("wasteInsulate1.zhi") }}
                <el-input v-model="col.max_size"></el-input>
                <el-select v-model="col.max_size_unit" placeholder="MB">
                  <el-option
                    v-for="item in size_unit"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <li>{{ $t("wasteInsulate1.attachment_size") }}:</li>
              <div class="mailSize">
                <el-input v-model="col.min_attsize"></el-input>
                <el-select v-model="col.min_attsize_unit" placeholder="MB">
                  <el-option
                    v-for="item in size_unit"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option> </el-select
                >{{ $t("wasteInsulate1.zhi") }}
                <el-input v-model="col.max_attsize"></el-input>
                <el-select v-model="col.max_attsize_unit" placeholder="MB">
                  <el-option
                    v-for="item in size_unit"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <li>{{ $t("wasteInsulate1.startdate") }}:</li>
              <el-date-picker
                v-model="col.startdate"
                type="datetimerange"
                :range-separator="$t('wasteInsulate1.zhi')"
                :start-placeholder="$t('table.sdata')"
                :end-placeholder="$t('table.enddata')"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
                :default-time="['00:00:00', '23:59:59']"
              ></el-date-picker>
            </ul>
          </div>
        </div>

        <!--  表格 -->

        <div class="table">
          <el-table
            v-loading="loading"
            :data="fileListnum"
             height="calc(100vh - 260px)"
            v-el-table-infinite-scroll="loadFile_list"
            :cell-class-name="tableCellClassName"
            :row-class-name="tableRowClassName"
            ref="multipleTable"
            tooltip-effect="dark"
            style="width: 100%"
             highlight-current-row
            @selection-change="handleSelectionChange"
            :row-key="getRowKeys"
            @cell-click="addSubAccount"
              @sort-change="sortChangeEvent"

          >
            <el-table-column
              type="selection"
              width="40"
              :reserve-selection="true"
              v-model="multipleSelection"
            ></el-table-column>
            <el-table-column :label="$t('table.tls')" width="40" v-if="this.ping_an_show==0">
              <template slot-scope="scope" v-if="ping_an_show==0">
                <img v-if="scope.row.SHOWTLS == 0" src="/imgs/tls2.png" alt />
                <img
                  v-if="scope.row.SHOWTLS == 1"
                  src="/imgs/tls.png"
                  alt
                  title="tls"
                />
                <img
                  v-if="scope.row.SHOW_WL == 1"
                  src="/imgs/wls.png"
                  alt
                  :title="$t('table.wl')"
                />
                <img v-if="scope.row.SHOW_WL == 0" src="/imgs/wls2.png" alt />
              </template>
            </el-table-column>

            <el-table-column
              prop="AC_DATE"
              :label="$t('table.maildate')"
              width="100"
                sortable="custom"
            >
            </el-table-column>
            <el-table-column
              prop="SHOW_MINION"
              :label="$t('table.clusterhost')"
              width="96"
               v-if="this.ping_an_show==0"
            ></el-table-column>
            <el-table-column prop="MID" :label="$t('table.ID')" width="92"  v-if="this.ping_an_show==0">
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.MID"
                  placement="top"
                >
                  <span > {{ scope.row.MID }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="IP" :label="$t('table.IP')" width="102"   sortable="custom"  v-if="this.ping_an_show==0">
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.IP"
                  placement="top"
                >
                  <span> {{ scope.row.IP }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <!--  发件人 -->

            <el-table-column
              sortable="custom"
              prop="ENVFROM"
              :label="$t('table.ENVFROM')"
             
            >
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.ENVFROM"
                  placement="top"
                >
                  <span :id="scope.row.REC_ID"> {{ scope.row.SHOW_ENVFROM }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <!--  收件人 -->

            <el-table-column
              sortable="custom"
              prop="ENVRCPT"
              :label="$t('table.ENVRCPT')"
             
            >
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.SHOW_MORE_RCPT"
                  placement="top"
                >
                  <span> {{ scope.row.ENVRCPT }}</span>
                </el-tooltip>
              </template>
              <!--  

                            <template slot-scope="scope">
                                <div>
                                    <p>
                                        {{
                        scope.row.SHOW_MORE == $t('table.show')
                          ? scope.row.SHOWRCPT
                          : scope.row.SHOW_MORE_RCPT
                      }}
                                        <el-button type="text" size="small" v-if="scope.row.SHOW_MORE" v-text="scope.row.SHOW_MORE" @click="handleEdit1(scope.$index, scope.row)"></el-button>
                                    </p>
                                </div>
                            </template>
                            -->
            </el-table-column>
            <!--  邮件主题-->

            <el-table-column
              prop="SUBJECT"
              :label="$t('table.SUBJECT')"
              sortable="custom"
            >
             <template slot-scope="scope" >
                <el-tooltip
                popper-class="tooltio_subject"
                  class="item tooltio_subject"
                  effect="dark"
                 
                  :content="scope.row.SUBJECT"
                  placement="top"
                >
                  <span >
                    {{ scope.row.SHOW_SUBJECT }}</span
                  >
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column
              prop="SHOW_REASON"
              :label="$t('table.SHOW_REASON')"
              width="92"
            ></el-table-column>
            <el-table-column
              prop="SIZE"
              :label="$t('table.mailsize')"
              width="60"
               sortable="custom"
            ></el-table-column>
          </el-table>
        </div>

        <!--  分页 -->
        <div class="fenye" v-show="xian6">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page"
           :page-sizes="this.q_page_size"
            :page-size="size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalnums"
          ></el-pagination>

          <!-- <button
            @click="openPostWindow"
            class="el-icon-download1"
            :disabled="$root.jurisdiction.only_query == 0"
          >
            {{ $t("table.download") }}
          </button> -->
          <!-- <button
            @click="bulkpass"
            class="el-icon-finished1"
            :disabled="$root.jurisdiction.only_query == 0"
            v-if="this.data_bulkpass_show == 1 &&this.authority_to_judge.pass==1"
          >
            {{ $t("table.pass") }}
          </button>
          <button
            @click="data_delete"
            class="el-icon-del1"
            :disabled="$root.jurisdiction.only_query == 0"
            v-if="this.authority_to_judge.delete==1"
          >
            {{ $t("table1.delete") }}
          </button> -->
            <!-- <el-dropdown
            trigger="click"
            class="collect"
           
           
          >
            <span
              class="el-dropdown-link"
              style="color: #006be7; margin-left: 10px"
            >
              {{ $t("table.more_operations")
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>

            <el-dropdown-menu slot="dropdown" class="show_style_drop">
            
             <ul
                class="tanchu_style"
              
               @click="openPostWindow"
              >
                <el-dropdown-item command="">
                  {{ $t("table.download") }}
                </el-dropdown-item>
              </ul>
              <ul
                class="tanchu_style"
              
                @click="archive_forward_tanchu"
              >
                <el-dropdown-item command="">
                  {{ this.data_forword }}
                </el-dropdown-item>
              </ul>
           
              <ul class="tanchu_style" @click="derived_record">
                <el-dropdown-item command="">
                  {{ $t("table1.export_email") }}
                </el-dropdown-item>
              </ul>
            </el-dropdown-menu>
          </el-dropdown> -->
   <img src="../../../public/imgs/area_bulk.png" title="放行" class="style_img_ara"  @click="bulkpass_img"  v-if="this.data_bulkpass_show == 1 &&this.authority_to_judge.pass==1">
     <img src="../../../public/imgs/area_down.png" title="下载邮件" class="style_img_ara"  @click="openPostWindow">
          <img src="../../../public/imgs/area_del.png" title="删除" class="style_img_ara"  @click="data_delete_img"   v-if="this.authority_to_judge.delete==1">
       
        
          <img src="../../../public/imgs/area_transmit.png" title="转发" class="style_img_ara"  @click="archive_forward_tanchu">
<img src="../../../public/imgs/area_derive.png" title="导出记录" class="style_img_ara" @click="derived_record">




             <div class="pop-up " v-show="derived_show"  v-drag="{ handle: '.pop_up_text_derived_record' }"
            >
              <!--  导出-->
              <div class="pop_up_text pop_up_text_derived_record">
                <span style="padding:0 14px"></span>{{ $t("table.record") }}
              </div>
              <p></p>
              <div class="find">
               
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- 条数 -->
                    {{ $t("logs.derived") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="limit_cn" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- 类型 -->
                    {{ $t("logs.smtpIp6") }}:
                  </div>
                  <div class="block block1">
                    <el-select
                      v-model="printtype"
                      placeholder=""
                     
                    >
                      <el-option
                        v-for="item in printtype_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                
                
               
                
               
               
              </div>

              <el-row>
                <el-button type="primary" @click="derived_unit">{{
                  $t("logs.report16")
                }}</el-button>
                <el-button type="danger" @click="derived_cancel">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="derived_show"></div>
        </div>
      </div>





  <div
        class="pop-up pop-up1"
        v-show="tanchu_forward"
        v-drag="{ handle: '.pop_up_text_relay_domain' }"
      >
        <div class="pop_up_text pop_up_text_relay_domain">
           <span class="span_pad"></span>{{ this.data_forword }}
        </div>
        <p></p>
        <div class="find">
          <div class="find1">
            <div class="find-text" style="padding-right:12px">
              {{ this.data_forword }}:
            </div>
            <div class="block block1" style="display:flex;margin:0px">
              <el-input v-model="forword_email" style="width:100%"></el-input>
            </div>
          </div>
        </div>

        <el-row>
          <el-button type="primary" @click="save_archiveforward()">{{
            $t("logs.transmit")
          }}</el-button>
          <el-button type="danger" @click="tanOff_archive_forward()">{{
            $t("tab.cancel")
          }}</el-button>
        </el-row>
      </div>
      <div class="gray" v-show="tanchu_forward"></div>
      <div
        class="xin1"
        id="main_btn1"
        v-loading="loading"
        v-show="this.list_two == 1"
      >
        <div class="swicth" style=" position: relative;">
          <!--内容区域 -->

          <div class="detail_type">
            <!-- 内容区域 -->
            <div class="cent">
              <!-- 分词信息 -->

              <ol class="reason" v-show="print2">
                <li>
                  {{ $t("list.info") }}:<el-button @click="yin4">{{
                    $t("list.hide")
                  }}</el-button>
                </li>

                <el-input type="textarea" :rows="10" v-model="print1">
                </el-input>
              </ol>
              <!-- 原始正文 -->

              <ol class="reason" v-show="original2">
                <li>
                  {{ $t("list.origin") }}:<el-button @click="yin3">{{
                    $t("list.hide")
                  }}</el-button>
                </li>

                <el-input type="textarea" :rows="10" v-model="original1">
                </el-input>
              </ol>
                  <!-- 详细信息 -->

            <ol class="reason" v-show="detail_show">
              <li>
                {{ $t("list.detail") }}:<el-button @click="yin_detail">{{
                  $t("list.hide")
                }}</el-button>
              </li>

              <el-input type="textarea" :rows="10" v-model="detail_info">
              </el-input>
            </ol>
              <!-- 正文分析 -->

              <ol class="reason" v-show="matter2">
                <li>
                  {{ $t("list.body") }}:<el-button @click="yin2">{{
                    $t("list.hide")
                  }}</el-button>
                </li>
                <li v-html="matter1"></li>
              </ol>
              <!-- 显示摘要 -->

              <ol class="reason" v-show="abstract2">
                <li>
                  {{ $t("list.show") }}:<el-button @click="yin1"  :disabled="$root.jurisdiction.only_query == 0">{{
                    $t("list.hide")
                  }}</el-button>
                </li>
                <li v-html="abstract1"></li>
              </ol>
              <!-- 原因分析 -->
              <ol class="reason" v-show="reason2">
                <li>
                  {{ $t("list.whyspam") }}:<el-button @click="yin"  :disabled="$root.jurisdiction.only_query == 0">{{
                    $t("list.hide")
                  }}</el-button>
                </li>

                <li style="white-space: pre-wrap;">{{ reason1 }}</li>
              </ol>

              <p v-html="fileList.SUBJECT"></p>

              <ul>
                <li>{{ $t("list.from") }}:</li>
                <li>
                  {{ fileList.FROMNAME }}
                  <span class="list_text">{{ fileList.FROMADDR }}</span>
                </li>
              </ul>
              <ul>
                <li>{{ $t("list.to") }}:</li>
                <li class="list_text">{{ fileList.TO }}</li>
              </ul>
              <ul v-if="this.fileList.CC">
                <li>{{ $t("list.cc") }}:</li>
                <li>{{ fileList.CC }}</li>
              </ul>
              <ul>
                <li>{{ $t("list.data") }}:</li>
                <li class="list_text">{{ fileList.DATE }}</li>
              </ul>
               <ul v-if="fileList.HAS_RECTIME==1">
                <li>{{ $t("list.record_time") }}:</li>
                <li class="list_text">{{ fileList.RECTIME }} </li>
              </ul>
              <ul v-if="fileList.ATTACHMENT == 1">
                <li>{{ $t("list.attach") }}:</li>
                <li class="yichu">
                  ({{ fnameage }} {{ $t("list.num") }} ){{ fname }}
                </li>
              </ul>
              <!--  信封发件人 -->
              <ul>
                <li>{{ $t("list.envfrom") }}:</li>
                <li>
                  {{ fileList.ENVFROM }}
                </li>
                <li v-if="fileList.ADD_BLACK_EMAIL_IN_SPAM == 1">
                  <el-button @click="tan1"  :disabled="$root.jurisdiction.only_query == 0">{{ $t("list.bte") }}</el-button>
                  <el-button @click="tan2 "  :disabled="$root.jurisdiction.only_query == 0">{{ $t("list.wte") }}</el-button>
                </li>
                <!-- 加白名单 -->
                <li v-if="fileList.ADD_WHITE_EMAIL_IN_USER_SPAM == 1">
                  <el-button @click="add_emali_white"  :disabled="$root.jurisdiction.only_query == 0">{{
                    $t("list.wte")
                  }}</el-button>
                </li>
                <li v-if="fileList.WHITE_EMAIL_IS_IN_USER_SPAM == 1">
                  {{ $t("tan.wte") }}
                  <el-button @click="del_email_white"  :disabled="$root.jurisdiction.only_query == 0">{{
                    $t("list.wte1")
                  }}</el-button>
                </li>
                <li v-if="fileList.BLACK_EMAIL_IS_IN_SPAM == 1">
                  {{ $t("tan.bte") }}
                  <el-button @click="tan11"  :disabled="$root.jurisdiction.only_query == 0">{{ $t("list.bte1") }}</el-button>
                </li>
                <li v-if="fileList.DELETE_WHITE_EMAIL_IN_SPAM == 1">
                  {{ $t("tan.wte") }}
                  <el-button @click="tan12"  :disabled="$root.jurisdiction.only_query == 0">{{ $t("list.wte1") }}</el-button>
                </li>
              </ul>
              <ul>
                <li>{{ $t("list.envrcpt") }}:</li>
                <li>{{ fileList.ENVRCPT }}</li>
              </ul>

              <ul>
                <li>{{ $t("list.id") }}:</li>
                <li>{{ fileList.QUEUE_ID }}</li>
              </ul>
              <ul>
                <li>{{ $t("list.ip") }}:</li>
                <li>
                  {{ fileList.PEER_IP }}
                </li>
                <li v-if="fileList.ADD_BLACK_IP_IN_SPAM == 1">
                  <el-button @click="tan3"  :disabled="$root.jurisdiction.only_query == 0">{{ $t("list.bti") }}</el-button>
                  <el-button @click="tan4 "  :disabled="$root.jurisdiction.only_query == 0">{{ $t("list.wti") }}</el-button>
                </li>

                <li v-if="fileList.DELETE_BLACK_IP_IN_SPAM == 1">
                  {{ $t("tan.bti1")
                  }}<el-button @click="tan13"  :disabled="$root.jurisdiction.only_query == 0">{{ $t("list.bti1") }}</el-button>
                </li>
                <li v-if="fileList.DELETE_WHITE_IP_IN_SPAM == 1">
                  {{ $t("tan.wti1") }}
                  <el-button @click="tan14"  :disabled="$root.jurisdiction.only_query == 0">{{ $t("list.wti1") }}</el-button>
                </li>
              </ul>
              <ul v-if="this.fileList.REPLY_TO_ADDR">
                <li>replyto:</li>
                <li>
                  {{ fileList.REPLY_TO_NAME
                  }}<span style="color:#818ea8;margin-left:4px"
                    >&lt;{{ fileList.REPLY_TO_ADDR }}&gt;</span
                  >
                </li>
              </ul>
              <ul v-if="this.fileList.SENDER_ADDR">
                <li>Sender:</li>
                <li>
                  {{ fileList.SENDER_NAME
                  }}<span style="color:#818ea8;margin-left:4px"
                    >&lt;{{ fileList.SENDER_ADDR }}&gt;</span
                  >
                </li>
              </ul>
            </div>
         
            <!-- 展示 -->
            <div class="cent2" id="cent2" v-html="html" v-if="this.authority_to_judge.see_body==1"></div>
            <!-- 附件 -->
            <div class="footer" v-if="fileList.ATTACHMENT == 1">
              <p>
                <img src="/imgs/fujian.png" alt />
                {{ $t("list.fu") }}({{ fnameage }} {{ $t("list.num") }})
              </p>
              <div v-for="v in fujian" :key="v.id">
                <img :src="`/imgs/${v.FILETYPE}.png`" alt />

                <ul>
                  <li>{{ v.NAME }}({{ v.HSIZE }})</li>
                  <li @click="down(v.CNT)">{{ $t("list.download") }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { list_policy_details, } from "../../tool/mixins.js";
import { garbageVirus } from "../../tool/elk_virus.js";
import { readmsg } from "../../tool/readmsg.js";
// import { splict_arr } from "../../tool/split_arrary.js";


export default {
   mixins: [list_policy_details,garbageVirus,readmsg,],
  data() {
    return {
      
       limit_cn_old:'',
       limit_cn:'',
      printtype:'pdf',
      printtype_arr:[],
      derived_show:false,
      authority_to_judge:[],
      options:[{
        value:1,
        label:'病毒'
      }]
    };
  },

  mounted() {
    
    this.getFileList_1();
 this.authority_to_judge=(JSON.parse(sessionStorage.getItem("usermsg")).common) ;
    console.log(this.col.startdate, "时间",this.authority_to_judge);
   
  },

 created() {
    let that = this;
        document.onkeydown = function (e) {
            e = window.event || e;
            // console.log(e.code)

            if ((e.code == 'Enter' || e.code == 'Num Enter' || e.code == 'NumpadEnter')) { //验证在登录界面和按得键是回车键enter
                that.tanSend(); //搜索函数 
            }
        }
  },
  methods: {
        // 导出记录事件
    derived_unit() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);

      let col_derived = JSON.parse(JSON.stringify(this.col_search));

      col_derived.limit_cn = this.limit_cn;
      col_derived.printtype = this.printtype;
      col_derived.printtofile = 1;
      let col = JSON.stringify(col_derived);


      if (this.printtype == "csv") {
        let __mode = "download_elk_rejectmail";
        window.open(
          `/api/adm/cgi/elkspam.cgi?__mode=${__mode}&sid=${sid}&col=${col}`
        );
      }
      if (this.printtype == "html" || this.printtype == "pdf") {
        let __mode = "list_elk_rejectmail";

        window.open(
          `/api/adm/cgi/elkspam.cgi?__mode=${__mode}&sid=${sid}&col=${col}`
        );
      }
      this.derived_show = false;
    },
    // 取消导出
    derived_cancel() {
      this.derived_show = false;
    },
    // 导出记录
    derived_record() {
       if (this.$root.jurisdiction.only_query != 0) {
      this.derived_show = true;
       }else{
          this.$message({

                    message: `${this.$t("tan.not_pre")}`,
                    type: "error",
                });
       }
      this.limit_cn = this.limit_cn_old;
    },
 save_archiveforward(){
    this.is_spam=1
    this.save_archive_forward()
  },
   
    handleCurrentChange2(val) {
      // console.log(`当前页: ${val}`);
      this.page = val;
      //  this.tanSend(this.search,this.pagesize)
      // console.log(this.page, '2', val);
    },
    // 打开详情页
    handleEdit(index, row) {
      // console.log(this.col1);
      // console.log(index,row)
      // this.loading = false;

      this.$router.push({
        name: "listOne1",
        params: {
          rec_id: row.REC_ID,
          index: row.INDEX,
          msgtype: row.MSGTYPE,
          is_elk: 1,
          col1: this.col1,
        },
      });
    },
    // 收件人展示更多

    handleEdit1(index, row) {
      console.log(row);
      this.fileList1[index].SHOW_MORE =
        row.SHOW_MORE == `${this.$t("table.show")}`
          ? `${this.$t("table.yin")}`
          : `${this.$t("table.show")}`;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-table__body tr:hover {
  cursor: pointer;
}

.biaodan {
  height: 300px;

  form {
    height: 300px;
  }
}

/deep/ .el-table--border th:first-child .cell {
  padding-left: 0px;
}

// 隐藏滚动条
// .el-table ::-webkit-scrollbar {
//   width: 0px;
//   background: none;
// }

/deep/ .el-table__row.el-table .cell:nth-child(1) {
  padding-left: 4px;
}

/deep/ .el-table .cell:nth-child(2) {
  padding-left: 0px;
}

// 滑过每一行变色
// /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
//   background-color: #c6cfdf !important;
// }

/deep/ .el-input__suffix {
  .el-input__suffix-inner {
    border-color: none;

    .el-icon-circle-close:before {
      padding-right: 10px;
    }
  }
}

// /deep/ .warning-row {
//   background: #f2f6fb;
// }

// /deep/ .success-row {
//   background: #fff;
// }

/deep/.el-table td {
  padding: 0px 0;
  // border-right: 1px solid #ccc;
  // border-bottom: 1px solid #ccc;
  box-sizing: border-box;
}

// /deep/.el-table td:first-child {
//     border-left: 1px solid #ccc;

// }

/deep/ .el-table th.gutter {
  display: table-cell !important;
}

/deep/ .el-table colgroup.gutter {
  display: table-cell !important;
}

// td
/deep/ .cell {
  // text-align: left;

  img {
    // margin-top: 3px;
    margin: 0 auto;
    width: 14px;
    height: 14px;
    // line-height: 20px;
    display: block;
  }

  .el-button {
    margin-left: 0;
  }
}

// /deep/.el-table__row td {
//     .cell {
//         text-align: left;
//     }
// }



.el-date-editor {
  margin-left: 10px;
  margin-top: 5px;
  // margin-bottom: 10px;
}

// /deep/ .el-input__inner {
//     padding-right: 36px;
// }

.search span {
  font-size: 14px;
  margin-left: 12px;
  color: #606266;
}

/deep/.el-tabs--border-card > .el-tabs__content {
  padding: 0;
  margin-top: 5px;
}


.jiqun {
  margin: 10px 0;
}

.block {
  display: flex;
  align-items: center;
}

.block span {
  margin: 0 38px;
}

/deep/ .el-range-editor.el-input__inner {
  display: flex;
  align-items: center;
}

.jiqun {
  display: flex;
  align-items: center;
  margin: 5px 0;
}

/deep/ .cell {
  text-align: center;
}

/deep/ .el-tabs__item {
  color: #333;
  font-size: 14px;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
  border-left: 1px solid #ddd;
  // border-right: 1px solid #fff;
}

/deep/ .el-tabs__nav-scroll {
  display: flex;
  padding-left: 0px;
  justify-content: space-between;
}

// background: #424F63;
/deep/ .el-tabs__item .is-top {
  font-size: 12px;
}

/deep/ .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 20px;
  border-left: 0px;
}

/deep/ .el-tabs--top .el-tabs__item.is-top:last-child {
  padding-right: 20px;
}

/deep/ .el-tabs__item.is-active {
  //   color: #409eff;
  background: #fff;
}

/deep/ .el-tabs__active-bar {
  height: 0;
}

/deep/ .el-date-editor {
  margin-top: 0;
}

/deep/ .el-date-editor .el-range-input {
  font-size: 12px;
  line-height: 24px;
  width: 50%;
}

/deep/.el-date-editor span {
  margin-bottom: 0px;
}

/deep/ .el-date-editor--datetimerange.el-input__inner {
  width: 330px;
}
@import "../../css/breadcrumb.less";

@import "../../css/liebiao.less";

@import "../../css/list_detail.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";

/deep/.el-table__row td:nth-child(2) {
  .cell {
    padding-left: 0px;
    display: flex;
    justify-content: space-around;
  }
}

/deep/.el-table--enable-row-hover .el-table__body .result_return > td {
  background: #99ccff !important;
}
/deep/ .sent1 .cell {
    color: #16960e;
}
.show_style_drop{
margin-bottom: 0px;
}
/deep/ .has-gutter th {
  text-align: left;
  .cell{
  text-align: left;

  }
}

/deep/.el-table__row td{
    .cell {
        text-align: left;
    }

    text-align: left;
}
/deep/ .has-gutter th:nth-child(1),/deep/.el-table__row td:nth-child(1){
      .cell{
  text-align: center;

  }
}
</style>
